import { Link } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <div className="NotFoundPage">
      <div className="m-auto max-w-md my-16">
        <p className="my-8 text-8xl">404</p>
        <p className="my-8 text-2xl font-bold">Sivua ei löydy!</p>
        <p>
          Näyttäisi siltä, että hakemaasi sivua ei löydy!
          Voit palata takaisin etusivulle <Link className="underline text-red-700" to="/">tästä</Link></p>
      </div>
    </div>
  )
};

export default NotFoundPage;